export default "__VITE_ASSET__CWjsMttN__"